import React, { Children, useState } from "react";
import TextField from "@mui/material/TextField";

// import JS files
import MuiTheme from "./MuiTheme";
import { useController } from "react-hook-form";

// import Others files

const ltrStyle = {
  direction: "ltr",
};
const rtlStyle = {
  direction: "rtl",
};

const MuiTextFieldHook = ({
  id,
  label,
  variant,
  size,
  name,
  control,
  register,
  isdisabled,
  isLTR,
  type,
  required,
  autoFocus,
}) => {
  let windowWidth = window.screen.width;
  const {
    field: { ref, ...restField },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: register,
    // defaultValue: defaultValue,
  });
  return (
    <>
      <MuiTheme>
        <div className="text-right">
          <TextField
            autoFocus={autoFocus}
            required={required}
            id={id}
            label={label}
            variant={variant}
            style={isLTR ? ltrStyle : rtlStyle}
            sx={{ width: "100%", input: { textAlign: "center" } }}
            size={size}
            name={name} // send down the input name
            inputRef={ref} // send input ref, so we can focus on input when error appear
            error={!!error}
            {...restField} // input value
            disabled={isdisabled ? true : false}
            type={type}
          />
          {error && (
            <span className="text-sm text-red-500 mt-2">{error.message}</span>
          )}
        </div>
      </MuiTheme>
    </>
  );
};

export default MuiTextFieldHook;
